import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import { getThemeClassNames } from 'themes';

import { MirrorService } from 'services/MirrorService';
import { AppDomain } from 'types/enums/AppDomain';

import { Funnels, getFunnelSearchString } from 'helpers/funnels/funnels';
import { useUpgradePageTransition } from 'hooks/useUpgradePageTransition';
import { getIsPremium, getIsVip, getUser } from 'store/auth/selectors';

import { ReactComponent as DiamondIcon } from 'assets/icons/diamond.svg';
import { ReactComponent as PremiumProfileIcon } from 'assets/icons/diamond-menu.svg';

import { BaseButton, ButtonTypes } from 'components/base/BaseButton';

import styles from './upgradeControls.module.sass';

export const UpgradeControls = () => {
  const { t } = useTranslation('app');
  const isVip = useSelector(getIsVip);
  const isPremium = useSelector(getIsPremium);
  const user = useSelector(getUser);

  const { handleSafePushUpgradePage } = useUpgradePageTransition();

  const handleUpgradeButtonClick = () => {
    const search = getFunnelSearchString(Funnels.GeneralButton);

    handleSafePushUpgradePage(search);
  };

  const rootClassName = getThemeClassNames(styles.upgradeBtn, {
    [AppDomain.MePlusYou]: styles.accent,
    [AppDomain.SweatHeartSoul]: styles.accent,
  });

  return (
    <div className={styles.wrapper}>
      {user && !isPremium && !isVip && (
        <BaseButton
          type={ButtonTypes.Accent}
          onClick={handleUpgradeButtonClick}
          className={cx(rootClassName)}
          small
        >
          <PremiumProfileIcon className={styles.premiumBtnIcon} fill="white" />
          {t('editProfile.header.upgradeToPremium')}
        </BaseButton>
      )}
      {isPremium && !isVip && !MirrorService.isGoogleCertificationsGroup && (
        <BaseButton
          type={ButtonTypes.Accent}
          className={cx(rootClassName)}
          to="/promote"
          small
        >
          <DiamondIcon className={styles.vipIcon} fill="white" />
          {t('editProfile.header.becomeVip')}
        </BaseButton>
      )}
    </div>
  );
};
